import { Typography } from 'antd';
import Profile from 'src/components/admin/profile';

export default function AdminProfile() {
  return (
    <>
      <Typography.Title
        level={2}
        style={{
          margin: '0 0 24px',
        }}
      >
        Profile Settings
      </Typography.Title>
      <Profile />
    </>
  );
}
